import { Component, Input } from "@angular/core";

@Component({
  selector: "mr-details-item",
  template: `
    @if (title) {
      <dt>{{ title }}</dt>
    }
    <dd><ng-content></ng-content></dd>
  `,
  styleUrls: ["./details-item.component.scss"],
  imports: [],
})
export class DetailsItemComponent {
  @Input() public title = "";
}
